<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card :header="'Add 360 Package Request'">
          <el-form label-width="160px" :model="form" ref="add360">
            <div v-if="step == 1" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Introduction</h5>
                  <p>This 360 module is AAI's full-service 360 module.</p>
                  <p>This import process focuses on automating the email distribution process. We automatically merge the same user into 1 final email. Meaning candidates who have to rate multiple people</p>
                  <p>&nbsp;</p>
                  <el-button @click="next()">Next</el-button>
                </el-col>
              </el-row>
            </div>

            <!-- Step 2 -->
            <div v-if="step == 2" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Upload File</h5>
                  <p>Please upload your file using the button below.</p>
                  <el-upload
                    class="upload-demo"
                    name="importFile"
                    :action="basePath + '/360/upload'"
                    :headers="getFileUploadHeaders"
                    :file-list="fileList"
                    :on-success="onSuccess"
                  >
                    <el-button size="small" type="primary">Click to upload</el-button>
                    <div slot="tip" class="el-upload__tip">csv files with a size less than 50MB</div>
                  </el-upload>
                </el-col>
              </el-row>
            </div>

            <!-- Step 3 -->
            <div v-if="step == 3" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <p>
                    <b>NOTE: Only showing the first 3 records of your file. The last page will show the final results of the import.</b> The purpose of only showing the first 3 records is so you can line up your records with our fields.
                  </p>
                  <p>Please use the form below to line up the columns:</p>
                  <el-checkbox v-model="skipTopRow" label="Top row is header information"></el-checkbox>
                </el-col>
              </el-row>
              <div class="table-responsive">
                <table class="table">
                  <tr>
                    <td v-for="(n, i) in sampledLines[0]" :key="i">
                      <select v-model="form.columnSort[i]">
                        <option v-for="c in columnSelection" :value="c.v" :key="c.$index">{{c.n}}</option>
                      </select>
                    </td>
                  </tr>
                  <tr v-for="(n, leIndex) in sampledLines" :key="leIndex">
                    <td v-for="nn in n" :key="nn.$index">{{nn}}</td>
                  </tr>
                </table>
              </div>

              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 4 -->
            <div v-if="step == 4" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>360 Selection</h5>
                  <p>Select the instrument the package will be based on.</p>
                  <el-form-item label="Instrument:" prop="instrument">
                    <el-select v-model="form.instrument" placeholder="Select Instrument">
                      <el-option
                        v-for="item in form.instrumentOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <p>&nbsp;</p>
                  <el-button @click="next()" :disabled="form.instrument === ''">Next</el-button>
                </el-col>
              </el-row>
            </div>

            <!-- Step 5 -->
            <div v-if="step == 5" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Distribution Name</h5>
                  <p>Choose a package name which will be easy for you to identify this package later to generate reports.</p>
                  <el-form-item label="Name:" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                  <p>&nbsp;</p>
                  <el-button @click="next()" :disabled="form.name === ''">Next</el-button>
                </el-col>
              </el-row>
            </div>

            <!-- Step 6 -->
            <div v-if="step == 6" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Organize your 360</h5>
                  <p>Organize your candidates, add names, and make tweaks.</p>
                  <el-tree
                    :data="final360data"
                    node-key="id"
                    default-expand-all
                    :expand-on-click-node="false"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                      <span>
                        <el-button type="text" size="mini" @click="() => append(data)">Append</el-button>
                        <el-button type="text" size="mini" @click="() => remove(node, data)">Delete</el-button>
                      </span>
                    </span>
                  </el-tree>
                  <p>&nbsp;</p>
                  <el-button @click="next()">Next</el-button>
                </el-col>
              </el-row>
            </div>

            <!-- Step 7 -->
            <div v-if="step == 7" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Email</h5>
                  <p>Adjust the email per your liking</p>
                  <p>
                    Available Tags:
                    <i>
                      [Company]
                      [UserEmail]
                      [ReportType]
                      [FirstName]
                      [LastName]
                      [Table]
                    </i>
                  </p>
                  <el-form-item label="Subject">
                    <el-input
                      :placeholder="'Please Enter a Subject Line'"
                      v-model="form.emailSubjectLine"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Message">
                    <el-input
                      v-model="form.emailMessage"
                      type="textarea"
                      :autosize="{ minRows: 10, maxRows: 25}"
                    ></el-input>
                  </el-form-item>

                  <p>&nbsp;</p>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 8 -->
            <div v-if="step == 8" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Review</h5>
                  <p>Please review the following.</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Instrument:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.instrumentNames[form.instrument]}}</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Name:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.name}}</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Size:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{storedFileName.numberLines}}</p>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <p>&nbsp;</p>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button
                        v-if="!importLoading"
                        @click.once="commitImport()"
                        type="primary"
                      >Import &amp; Email</el-button>
                      <div v-if="importLoading">Loading ...</div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 9 - Done -->
            <div v-if="step == 9" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Final Summary</h5>
                  <p>
                    Package
                    <router-link :to="'/360/dash/' + finished.packageId">{{form.name}}</router-link>&nbsp;has been created.
                  </p>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { unserialize } from '../../../shared/unserialize.js';
import { basePath } from '../../../shared/basePath';
import axios from '../../../shared/axios';
import { setTimeout } from 'timers';

export default {
  computed: {
    ...mapGetters('auth', ['getToken', 'getCompanyName']),
    getFileUploadHeaders() {
      const split = ' ';
      const headerKey = 'Bearer';
      return {
        authorization: headerKey + split + String(this.getToken)
      };
    }
  },
  data() {
    return {
      importLoading: false,
      skipTopRow: false,
      basePath: basePath(),
      step: 1,
      form: {
        instrument: undefined,
        name: undefined,
        languageOptions: [],
        instrumentOptions: [],
        instrumentNames: [],
        storedFileName: undefined,
        columnSort: [],
        sendEmail: false,
        emailSubjectLine: '',
        emailMessage: ''
      },
      allData: [],
      final360data: [],
      storedFileName: undefined,
      fileList: [],
      sampledLines: undefined,
      totalImport: undefined,
      columnSelection: [
        { v: 'skip', n: '--Skip--' },
        { v: 'first_name', n: 'First Name' },
        { v: 'last_name', n: 'Last Name' },
        { v: 'e_mail_1', n: 'Email' },
        { v: 'relationship', n: 'Relationship' },
        { v: 'ratee', n: 'Ratee' }
      ],
      finished: {
        packageId: undefined
      }
    };
  },
  watch: {
    step(n) {
      if (n === 4) {
        for (const inc in this.allData) {
          const leData = this.allData[inc];
          let label = '';
          let fName = '';
          let lName = '';
          let email = '';
          for (const colInc in this.form.columnSort) {
            const obj = this.form.columnSort[colInc];
            switch (obj) {
              case 'first_name':
                fName = this.allData[inc][colInc];
                break;
              case 'last_name':
                lName = this.allData[inc][colInc];
                break;
              case 'e_mail_1':
                email = this.allData[inc][colInc];
                break;
            }
            // deliverable[obj] = this.allData[inc][colInc];
          }
          let deliverable = {
            id: email,
            label: fName + ' ' + lName
          };
          this.final360data.push(deliverable);
        }
        console.log(this.final360data);
      }
    }
  },
  created() {
    axios.get('/settings/get').then(r => {
      this.settings = Object.assign({}, r.data.rawSettings);
      // console.log(this.settings);
      this.form.emailSubjectLine = this.settings.invite_subject_line;
      this.form.emailMessage = this.settings.invite_message;
    });
    axios
      .get('360/instruments')
      .then(r => {
        const lang = [];
        const inst = [];

        // Languages
        for (const i in r.data.languages) {
          lang.push({
            value: r.data.languages[i].lang_abrv,
            label: r.data.languages[i].lang_fullname
          });
        }

        // Instruments
        const enabledTests = [];
        for (const ii in r.data.enabledTests) {
          enabledTests.push(r.data.enabledTests[ii].test_id);
        }
        for (const iii in r.data.tests) {
          if (enabledTests.indexOf(r.data.tests[iii].test_id) === -1) {
            continue;
          }
          if (
            r.data.options[r.data.tests[iii].test_id] === undefined ||
            r.data.options[r.data.tests[iii].test_id].options.instrument_type ==
              'Single'
          ) {
            continue;
          }

          inst.push({
            value: r.data.tests[iii].test_id,
            label: r.data.tests[iii].test_name_eng
          });
          const id = r.data.tests[iii].test_id;
          this.form.instrumentNames[id] = r.data.tests[iii].test_name_eng;
        }

        this.form.languageOptions = lang;
        this.form.instrumentOptions = inst;
      })
      .catch(e => {
        console.log(e);
      });
  },
  methods: {
    append(data) {
      const newChild = { id: data.id++, label: 'testtest', children: [] };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },
    previous() {
      this.step -= 1;
    },
    next() {
      this.step += 1;
    },
    onSuccess(res, file) {
      // console.log(res);
      this.storedFileName = res;
      this.form.storedFileName = res.storedFiledName; // store the actual name
      this.sampledLines = Object.assign([], res.headerLines);
      this.totalImport = res.numberLines;
      this.allData = res.allData;
      // console.log(this.sampledLines);
      this.step = 3;
    },
    commitImport() {
      this.importLoading = true;
      axios
        .post('/360/finalize', this.form)
        .then(r => {
          this.step = 9;
          this.finished.packageId = r.data.packageId;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>